import { formatARSExact } from "../lib/money";
import { Button } from "./Button";

type Props = {
  /** Amount that the API asked the operator to review. */
  amountCents: number;
  /** Name of the operation being confirmed, for example "Registrar egreso". */
  actionLabel: string;
  pending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * An explicit, non-destructive confirmation shown after the API flags an
 * unusual amount. It deliberately lives inside the original form sheet: the
 * original request remains frozen and confirmation retries that exact body.
 */
export function MoneyConfirmationPanel({
  amountCents,
  actionLabel,
  pending = false,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <div
      role="alertdialog"
      aria-live="assertive"
      aria-label="Confirmar importe inusual"
      style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
        <p style={{ margin: 0, color: "var(--text-primary)", fontWeight: 600, fontSize: "var(--font-size-18)" }}>
          Confirmá el importe
        </p>
        <p className="num" style={{ margin: 0, color: "var(--color-warning)", fontSize: "var(--font-size-24)", fontWeight: 700 }}>
          {formatARSExact(amountCents)}
        </p>
        <p style={{ margin: 0, color: "var(--text-secondary)", lineHeight: 1.45 }}>
          Es un importe inusualmente alto. Revisalo antes de guardarlo: todavía no se registró ningún movimiento.
        </p>
      </div>

      <Button variant="primary" fullWidth size="lg" onClick={onConfirm} disabled={pending}>
        {pending ? "Guardando..." : actionLabel}
      </Button>
      <Button variant="ghost" fullWidth size="lg" onClick={onCancel} disabled={pending}>
        Volver a editar
      </Button>
    </div>
  );
}
